import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const currencyFormatter = (value) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

export const columns = [
  {
    name: "Borough",
    accessor: "location_html",
  },
  {
    name: "Rental Cost Per Sq. m.",
    accessor: "cost_per_sq_metre",
    formatter: currencyFormatter,
  },
];

export const rows = [
  {
    location_html: "Kensington & Chelsea",
    cost_per_sq_metre: 72.4,
    monthly_rental_single: 2823.6,
    yearly_income_single: 116838.6,
    monthly_rental_family: 5357.6,
    yearly_income_family: 221693.76,
  },
  {
    location_html: "City of Westminster",
    cost_per_sq_metre: 54.82,
    monthly_rental_single: 2137.98,
    yearly_income_single: 88468.08,
    monthly_rental_family: 4056.68,
    yearly_income_family: 167862.6,
  },
  {
    location_html: "City of London",
    cost_per_sq_metre: 44.42,
    monthly_rental_single: 1732.38,
    yearly_income_single: 71684.64,
    monthly_rental_family: 3287.08,
    yearly_income_family: 136017.12,
  },
  {
    location_html: "Camden",
    cost_per_sq_metre: 39.5,
    monthly_rental_single: 1540.5,
    yearly_income_single: 63744.84,
    monthly_rental_family: 2923,
    yearly_income_family: 120951.72,
  },
  {
    location_html: "Hammersmith & Fulham",
    cost_per_sq_metre: 32.86,
    monthly_rental_single: 1281.54,
    yearly_income_single: 53029.2,
    monthly_rental_family: 2431.64,
    yearly_income_family: 100619.64,
  },
  {
    location_html: "Islington",
    cost_per_sq_metre: 32.34,
    monthly_rental_single: 1261.26,
    yearly_income_single: 52190.04,
    monthly_rental_family: 2393.16,
    yearly_income_family: 99027.36,
  },
  {
    location_html: "Wandsworth",
    cost_per_sq_metre: 31.69,
    monthly_rental_single: 1235.91,
    yearly_income_single: 51141.12,
    monthly_rental_family: 2345.06,
    yearly_income_family: 97036.92,
  },
  {
    location_html: "Southwark",
    cost_per_sq_metre: 31.29,
    monthly_rental_single: 1220.31,
    yearly_income_single: 50495.64,
    monthly_rental_family: 2315.46,
    yearly_income_family: 95812.08,
  },
  {
    location_html: "Lambeth",
    cost_per_sq_metre: 30.53,
    monthly_rental_single: 1190.67,
    yearly_income_single: 49269.12,
    monthly_rental_family: 2259.22,
    yearly_income_family: 93484.92,
  },
  {
    location_html: "Haringey",
    cost_per_sq_metre: 26.65,
    monthly_rental_single: 1039.35,
    yearly_income_single: 43007.64,
    monthly_rental_family: 1972.1,
    yearly_income_family: 81604.08,
  },
  {
    location_html: "Hackney",
    cost_per_sq_metre: 25.72,
    monthly_rental_single: 1003.08,
    yearly_income_single: 41506.8,
    monthly_rental_family: 1903.28,
    yearly_income_family: 78756.36,
  },
  {
    location_html: "Richmond upon Thames",
    cost_per_sq_metre: 23.49,
    monthly_rental_single: 916.11,
    yearly_income_single: 37908,
    monthly_rental_family: 1738.26,
    yearly_income_family: 71928,
  },
  {
    location_html: "Merton",
    cost_per_sq_metre: 22.42,
    monthly_rental_single: 874.38,
    yearly_income_single: 36181.2,
    monthly_rental_family: 1659.08,
    yearly_income_family: 68651.64,
  },
  {
    location_html: "Tower Hamlets",
    cost_per_sq_metre: 21.7,
    monthly_rental_single: 846.3,
    yearly_income_single: 35019.36,
    monthly_rental_family: 1605.8,
    yearly_income_family: 66446.88,
  },
  {
    location_html: "Barnet",
    cost_per_sq_metre: 21.67,
    monthly_rental_single: 845.13,
    yearly_income_single: 34970.88,
    monthly_rental_family: 1603.58,
    yearly_income_family: 66355.08,
  },
  {
    location_html: "Brent",
    cost_per_sq_metre: 20.89,
    monthly_rental_single: 814.71,
    yearly_income_single: 33712.08,
    monthly_rental_family: 1545.86,
    yearly_income_family: 63966.6,
  },
  {
    location_html: "Kingston upon Thames",
    cost_per_sq_metre: 20.5,
    monthly_rental_single: 799.5,
    yearly_income_single: 33082.8,
    monthly_rental_family: 1517,
    yearly_income_family: 62772.36,
  },
  {
    location_html: "Ealing",
    cost_per_sq_metre: 20.47,
    monthly_rental_single: 798.33,
    yearly_income_single: 33034.32,
    monthly_rental_family: 1514.78,
    yearly_income_family: 62680.56,
  },
  {
    location_html: "Enfield",
    cost_per_sq_metre: 19,
    monthly_rental_single: 741,
    yearly_income_single: 30662.04,
    monthly_rental_family: 1406,
    yearly_income_family: 58179.36,
  },
  {
    location_html: "Waltham Forest",
    cost_per_sq_metre: 17.7,
    monthly_rental_single: 690.3,
    yearly_income_single: 28564.08,
    monthly_rental_family: 1309.8,
    yearly_income_family: 54198.6,
  },
  {
    location_html: "Hounslow",
    cost_per_sq_metre: 17.47,
    monthly_rental_single: 681.33,
    yearly_income_single: 28192.92,
    monthly_rental_family: 1292.78,
    yearly_income_family: 53494.32,
  },
  {
    location_html: "Harrow",
    cost_per_sq_metre: 17.17,
    monthly_rental_single: 669.63,
    yearly_income_single: 27708.84,
    monthly_rental_family: 1270.58,
    yearly_income_family: 52575.72,
  },
  {
    location_html: "Lewisham",
    cost_per_sq_metre: 16.82,
    monthly_rental_single: 655.98,
    yearly_income_single: 27144,
    monthly_rental_family: 1244.68,
    yearly_income_family: 51504,
  },
  {
    location_html: "Greenwich",
    cost_per_sq_metre: 16.52,
    monthly_rental_single: 644.28,
    yearly_income_single: 26659.92,
    monthly_rental_family: 1222.48,
    yearly_income_family: 50585.4,
  },
  {
    location_html: "Newham",
    cost_per_sq_metre: 16.5,
    monthly_rental_single: 643.5,
    yearly_income_single: 26627.64,
    monthly_rental_family: 1221,
    yearly_income_family: 50524.08,
  },
  {
    location_html: "Sutton",
    cost_per_sq_metre: 16.08,
    monthly_rental_single: 627.12,
    yearly_income_single: 25949.76,
    monthly_rental_family: 1189.92,
    yearly_income_family: 49238.04,
  },
  {
    location_html: "Redbridge",
    cost_per_sq_metre: 15.92,
    monthly_rental_single: 620.88,
    yearly_income_single: 25691.64,
    monthly_rental_family: 1178.08,
    yearly_income_family: 48748.08,
  },
  {
    location_html: "Hillingdon",
    cost_per_sq_metre: 15.83,
    monthly_rental_single: 617.37,
    yearly_income_single: 25546.32,
    monthly_rental_family: 1171.42,
    yearly_income_family: 48472.56,
  },
  {
    location_html: "Bromley",
    cost_per_sq_metre: 15.7,
    monthly_rental_single: 612.3,
    yearly_income_single: 25336.56,
    monthly_rental_family: 1161.8,
    yearly_income_family: 48074.52,
  },
  {
    location_html: "Croydon",
    cost_per_sq_metre: 15.3,
    monthly_rental_single: 596.7,
    yearly_income_single: 24691.08,
    monthly_rental_family: 1132.2,
    yearly_income_family: 46849.68,
  },
  {
    location_html: "Barking & Dagenham",
    cost_per_sq_metre: 14.94,
    monthly_rental_single: 582.66,
    yearly_income_single: 24110.04,
    monthly_rental_family: 1105.56,
    yearly_income_family: 45747.36,
  },
  {
    location_html: "Havering",
    cost_per_sq_metre: 13.88,
    monthly_rental_single: 541.32,
    yearly_income_single: 22399.44,
    monthly_rental_family: 1027.12,
    yearly_income_family: 42501.48,
  },
  {
    location_html: "Bexley",
    cost_per_sq_metre: 13.3,
    monthly_rental_single: 518.7,
    yearly_income_single: 21463.44,
    monthly_rental_family: 984.2,
    yearly_income_family: 40725.48,
  },
];
